import { Link } from 'react-router-dom';

export function Footer() {
  const services = [
    'Automotive Window Tinting',
    'Residential Window Tinting',
    'Marine Window Tinting',
    'Paint Protection Film',
    'Ceramic Coatings',
  ];

  const links = [
    { label: 'Home', href: '/' },
    { label: 'Services', href: '/services' },
    { label: 'About Us', href: '/about' },
    { label: 'Locations', href: '/locations' },
    { label: 'Get a Quote', href: '#quote' },
  ];

  return (
    <footer className="bg-[#080808] text-white">
      {/* Top CTA strip */}
      <div className="border-b border-white/5 py-8">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col sm:flex-row items-center justify-between gap-5">
          <div>
            <p className="text-white font-semibold text-base" style={{ fontFamily: 'Sora, sans-serif' }}>
              Ready to transform your vehicle or home?
            </p>
            <p className="text-white/40 text-sm mt-0.5">Free quotes · Same-day automotive service available</p>
          </div>
          <div className="flex gap-3 flex-shrink-0">
            <a
              href="tel:+15612759473"
              className="inline-flex items-center gap-2 border border-white/20 text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-white/5 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-[#FF6B35]" />
              (561) 275-9473
            </a>
            <a
              href="#quote"
              className="bg-[#FF6B35] hover:bg-[#E55A2B] text-white px-5 py-2.5 rounded-full text-sm font-bold transition-all cursor-pointer whitespace-nowrap"
            >
              Get Free Quote
            </a>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://mrtintofamerica.com/wp-content/uploads/2024/11/MR-TINT-LOGO-Whitetxt.png"
              alt="Mr. Tint of America"
              className="h-16 w-auto mb-5"
            />
            <p className="text-white/40 text-sm leading-relaxed mb-6">
              Professional window tinting, PPF, and ceramic coatings for automotive, residential, and marine applications throughout South Florida.
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-facebook-fill', label: 'Facebook' },
                { icon: 'ri-instagram-line', label: 'Instagram' },
                { icon: 'ri-youtube-fill', label: 'YouTube' },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-xl bg-white/5 hover:bg-[#FF6B35] transition-all cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-white/70 mb-5" style={{ fontFamily: 'Sora, sans-serif' }}>
              Services
            </h3>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s}>
                  <a href="#services" className="text-white/40 hover:text-[#FF6B35] text-sm transition-colors cursor-pointer">
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-white/70 mb-5" style={{ fontFamily: 'Sora, sans-serif' }}>
              Quick Links
            </h3>
            <ul className="space-y-3">
              {links.map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="text-white/40 hover:text-[#FF6B35] text-sm transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-white/70 mb-5" style={{ fontFamily: 'Sora, sans-serif' }}>
              Contact
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#FF6B35] text-base mt-0.5 flex-shrink-0" />
                <span className="text-white/40 text-sm">1257 SW Martin Hwy<br />Palm City, FL 34990</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-[#FF6B35] text-base flex-shrink-0" />
                <a href="tel:+15612759473" className="text-white/40 hover:text-[#FF6B35] text-sm transition-colors cursor-pointer">
                  (561) 275-9473
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-[#FF6B35] text-base mt-0.5 flex-shrink-0" />
                <span className="text-white/40 text-sm">Mon–Fri: 8AM–6PM<br />Sat: 9AM–4PM</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-xs">
            © 2026 Mr. Tint of America. All rights reserved. | Window Tinting Palm City, FL
          </p>
          <div className="flex items-center gap-6">
            <img
              src="https://mrtintofamerica.com/wp-content/uploads/2024/11/visa-mastercard-amex-discov.webp"
              alt="Payment Methods"
              className="h-6 opacity-30"
            />
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-6 lg:px-12 pb-8">
          <img
            src="https://mrtintofamerica.com/wp-content/uploads/2024/11/AffiliatesFooter.webp"
            alt="Affiliated Brands — 3M, LLumar, XPEL"
            className="h-8 opacity-20"
          />
        </div>
      </div>
    </footer>
  );
}
